import React from 'react';
import Button from "../../../../../../components/button";
import {connect} from 'react-redux';
import { useTranslation } from 'react-i18next';
import './index.css';

const tryHandler = (props)=>(e) => {
	e.preventDefault();
	if(props.profile.isAdmin){
		window.location.href = 'https://workspace.google.com/marketplace/app/shared_contacts_for_gmail%C2%AE_share_google/1033860418004?authuser=' + props.profile.email;
	}else{
	 window.location.href = '/account/try';
	}
};

const buyHandler = (e) => {
	e.preventDefault();
	window.location.href = '/api/payment/new';
};

const ChoosePlan = (props) => {
	const { t } = useTranslation();

    return (
        <div className="choose-plan p-4">
			<h2 className="mb-3">{t("textChoosePlan4")}</h2>
			<p className="mb-1">{t("textChoosePlan5")}</p>
			<h3 className="text-dark mb-4 font-weight-bold">{t("textChoosePlan6")}</h3>
			<div className="d-flex justify-content-around align-items-stretch">
				<div className="bg-light text-center w-50 rounded mr-3 p-3">
					<p><img src={'/img/balloon.svg'} alt="Balloon"/></p>
					<p><strong>{t("textFreeTrial")}</strong><br/><small>{t("InviteToSharepopup")}</small></p>
					<Button className="btn-primary" onClick={tryHandler(props)}>Start my trial now</Button>
				</div>
                <div className="bg-light text-center w-50 rounded ml-3 p-3">
                    <p><img src={'/img/origami.svg'} alt="Balloon"/></p>
                    <p><strong>{t("textChoosePlan3")}</strong></p>
                    <Button className="btn-orange text-white" onClick={buyHandler}>{t("textBuy")}</Button>
                </div>
			</div>
        </div>
    );
};

const mapStateToProps = (state) => ({
	profile: state.profileReducer.getProfile,
});


export default connect(mapStateToProps, null)(ChoosePlan);
